import React from "react";
import {
  ServicePanelSplit,
  ServiceDescriptionRow,
  PanelRows,
  PanelInputRows,
} from "../Common/ServiceItem";
import { useSelector, useDispatch } from "react-redux";
import { conformToCurrency } from "../Common/Currency";
import { AddProductAmount } from "./PopularProductsFeatureSpotSlice";
import img from "../../Images/PopularProductsFeatureSpot.png";
import { ImgWrapper } from "../../Images/index";

export const PopularProductsPanel = () => {
  const {
    ProductsQuantity,
    NumberOfMonthPerProduct,
    PerProductPerMonth,
    total,
  } = useSelector((state) => state.PopularProductsFeatureSpotReducer);
  const dispatch = useDispatch();
  const PanelInputArray = [
    {
      label: "Number of Products Selected",
      value: ProductsQuantity,
      onChange: (ev) => dispatch(AddProductAmount(ev.target.value)),
    },
  ];

  const PanelArray = [
    {
      label: "Number of months per products ",
      value: NumberOfMonthPerProduct,
    },
    {
      label: "Cost per month per product",
      value: conformToCurrency(PerProductPerMonth),
    },
    {
      label: "Total Cost",
      value: conformToCurrency(total),
    },
  ];

  return (
    <>
      <PanelInputRows PanelArray={PanelInputArray} />
      <PanelRows PanelArray={PanelArray} />
    </>
  );
};

export const PopularProductsFeatureSpot = () => {
  return (
    <div>
      <ServiceDescriptionRow>
        Feature one of your products in the Popular Products. Feature Spot for 1
        month, 1 product per order.
      </ServiceDescriptionRow>
      <ServicePanelSplit
        item1={<ImgWrapper src={img} />}
        item2={<PopularProductsPanel />}
      />
    </div>
  );
};
